export enum CertificateCreationDates {
  APRIL_2014 = 'APRIL_2014',
  MAY_2014 = 'MAY_2014',
  NOT_NECESSARY = 'NOT_NECESSARY',
  WITHOUT = 'WITHOUT'
}
